import { sendMessageToIframe } from '../../services/parentService'

export const toggleLibrary = (
    container: HTMLElement,
    libIframe: HTMLIFrameElement,
    forceValue: boolean | null = null // Pass true to force open, false to force close
) => {
    if (forceValue !== null) {
        // Force open or force close
        container.style.transform = forceValue
            ? 'translateX(0%)'
            : 'translateX(100%)'
    } else {
        // Toggle
        const isOpened = container.style.transform === 'translateX(0%)'
        container.style.transform = isOpened
            ? 'translateX(100%)'
            : 'translateX(0%)'
    }

    sendMessageToIframe(
        libIframe,
        container.style.transform === 'translateX(0%)'
            ? 'LIB_OPENED'
            : 'LIB_CLOSED'
    )
}
